export function formatNumber(
  value: number,
  decimals = 2,
  locale = 'fr-BE'
): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}